import { fetchData } from "../../helpers/api";

export async function fetchHouseMeasuresData(filters) {
  const { code, reportName, propType, queryParams, token } = filters;

  if (token) {
    queryParams.append("token", token);
  }

  return fetchData({
    endpoint: `widgets/:reportName/:propType/:code/housemeasures/`,
    params: { reportName, propType, code },
    queryParams,
    errorFlag: "WidgetError",
  });
}
